import styled from 'styled-components';

import { colour, spacing, typography, media } from '../../../../theme';

export const StyledButton = styled.a<{
  as: 'a' | 'button';
}>`
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: none;
  display: inline-flex;
  align-items: center;
  gap: ${spacing.spacing0};
  font-size: 1.125rem;
  font-family: ${typography.fontPrimary};
  font-weight: ${typography.fontWeightRegular};
  line-height: calc(14 / 9);
  margin: ${spacing.spacing0} ${spacing.spacing0} ${spacing.spacing4} ${
  spacing.spacing0
};
  min-width: 10rem;
  padding: calc((${spacing.spacing4} + ${spacing.spacing1}) / 2) ${
  spacing.spacing5
};
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  width: 100%;
  white-space: nowrap;
  justify-content: flex-start;
  padding-left: ${spacing.spacing2};

  svg {
    margin-right: 0.25rem;
    color: rgb(0, 102, 204);
    width: 0.9rem;
    height: 0.9rem;
  }
  svg {
    flex-shrink: 0;
    display: block;
  }

  &:focus,
  &:active {
    box-shadow: 0 0 0 4px ${colour.focusBlue};
    outline: 4px solid transparent;
    transition: box-shadow 0.1s ease-in-out;
  }

  @media ${media.small} {
    margin: ${spacing.spacing0} ${spacing.spacing4} ${spacing.spacing4} ${
  spacing.spacing0
};
    width: auto;
  }

  ${(props) => {
    if (props.color === 'primary') {
      return `
		background-color: ${colour.btnPrimaryBG};
		border: 2px solid ${colour.btnPrimaryBG};
		color: ${colour.palette.white};

		&:hover {
			background-color: ${colour.btnPrimaryHover};
			border: 2px solid ${colour.btnPrimaryHover};
			color: ${colour.palette.white};
		}

		&:focus {
			background-color: ${colour.btnPrimaryHover};
			border: 2px solid ${colour.btnPrimaryHover};
			color: ${colour.palette.white};
			transition: background-color .2s ease-out, box-shadow 0.1s ease-in-out;
		}

		&:active {
			background-color: ${colour.btnPrimaryActive};
			border: 2px solid ${colour.btnPrimaryActive};
			color: ${colour.palette.white};
			transition: background-color 0s, box-shadow 0.1s ease-in-out;
		}

		&:visited {
			color: ${colour.palette.white};
		}
	`;
    }
    if (props.color === 'secondary') {
      return `
		background-color: ${colour.btnSecondaryBG};
		border: 2px solid ${colour.baseLink};
		color: ${colour.baseLink};

		&:hover {
			background-color: ${colour.btnSecondaryHover};
			border-color: ${colour.baseLinkHover};
			color: ${colour.baseLinkHover};
		}

		&:focus {
			background-color: ${colour.btnSecondaryHover};
			border-color: ${colour.baseLinkHover};
			color: ${colour.baseLinkHover};
			transition: background-color .2s ease-out, box-shadow 0.1s ease-in-out;
		}

		&:active {
			background-color: ${colour.btnSecondaryActive};
			border-color: ${colour.baseLinkActive};
			color: ${colour.baseLinkActive};
			transition: background-color 0s, box-shadow 0.1s ease-in-out;
		}

		&:visited {
			color: ${colour.baseLink};
		}
	`;
    }
    return `
		background-color: ${colour.btnTertiaryBG};
		color: ${colour.baseLink};
		text-decoration: underline;
		min-width: 3rem;
		width: unset;
		white-space: nowrap;
		font-weight: 600;
		justify-content: flex-start;
		padding-left: 0.5rem;
		padding-right: 1rem;
		margin: 0.75rem 0 !important;

		&:hover {
			background-color: ${colour.btnTertiaryHover};
			color: ${colour.btnPrimaryHover};
			text-decoration: underline;
		}

		&:focus {
			background-color: ${colour.btnTertiaryHover};
			color: ${colour.baseLinkHover};
			text-decoration: underline;
			transition: background-color .2s ease-out, box-shadow 0.1s ease-in-out;
		}

		&:active {
			background-color: ${colour.btnTertiaryActive};
			color: ${colour.baseLinkActive};
			text-decoration: underline;
			transition: background-color 0s, box-shadow 0.1s ease-in-out;
		}

		&:visited {
			color: ${colour.baseLink};
		}

		@media only screen and (max-width: 600px) {
			margin: 0 !important;
			padding-left: 0;
			padding-right: 0.5rem;
			width: auto;
			max-width: 100%;
			white-space: normal;

			svg {
				margin-right: ${spacing.spacing1};
			}
		}`;
  }}}
`;

export default {
  StyledButton,
};
